import React from 'react';
import FileDownloadPage from './file-download';

export default function render(entry) {
    return <FileDownloadPage entry={entry} />;
}
